export const EMBLEM_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_forge-worlds-2/artifacts/dt8yunjw_Arsenal%20Forge.png";

export const IMG = {
  heroLandscape:
    "https://images.unsplash.com/photo-1597839219216-a773cb2473e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxkYXJrJTIwY2luZW1hdGljJTIwZ2FtZSUyMGxhbmRzY2FwZSUyMGZhbnRhc3klMjBzY2ktZml8ZW58MHx8fHwxNzkwNjkxOTIxfDA&ixlib=rb-4.1.0&q=85",
  keyArt:
    "https://images.unsplash.com/photo-1475070929565-c985b496cb9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2luZW1hdGljJTIwZ2FtZSUyMGxhbmRzY2FwZSUyMGZhbnRhc3klMjBzY2ktZml8ZW58MHx8fHwxNzkwNjkxOTIxfDA&ixlib=rb-4.1.0&q=85",
  mountainBiome:
    "https://images.unsplash.com/photo-1670702146868-bc7797ef47a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxkYXJrJTIwY2luZW1hdGljJTIwZ2FtZSUyMGxhbmRzY2FwZSUyMGZhbnRhc3klMjBzY2ktZml8ZW58MHx8fHwxNzkwNjkxOTIxfDA&ixlib=rb-4.1.0&q=85",
  forgeSparks:
    "https://images.unsplash.com/photo-1707855857402-65b865e8f35d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZGFyayUyMG1ldGFsJTIwc3BhcmtzJTIwZm9yZ2UlMjBhdG1vc3BoZXJpY3xlbnwwfHx8fDE3OTA2OTE5MjF8MA&ixlib=rb-4.1.0&q=85",
  welderCraft:
    "https://images.unsplash.com/photo-1740072161824-cc5e9517290c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZGFyayUyMG1ldGFsJTIwc3BhcmtzJTIwZm9yZ2UlMjBhdG1vc3BoZXJpY3xlbnwwfHx8fDE3OTA2OTE5MjF8MA&ixlib=rb-4.1.0&q=85",
  emberBg:
    "https://images.unsplash.com/photo-1746853772442-053f9f76b3ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZGFyayUyMG1ldGFsJTIwc3BhcmtzJTIwZm9yZ2UlMjBhdG1vc3BoZXJpY3xlbnwwfHx8fDE3OTA2OTE5MjF8MA&ixlib=rb-4.1.0&q=85",
  studioSetup:
    "https://images.unsplash.com/photo-1514168757508-07ffe9ae125b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxnYW1lJTIwZGV2ZWxvcGVyJTIwc3R1ZGlvJTIwZGFyayUyMGF0bW9zcGhlcmUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA2OTE5MjF8MA&ixlib=rb-4.1.0&q=85",
  studioWork:
    "https://images.unsplash.com/photo-1562813733-b31f71025d54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxnYW1lJTIwZGV2ZWxvcGVyJTIwc3R1ZGlvJTIwZGFyayUyMGF0bW9zcGhlcmUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA2OTE5MjF8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "GAMES", to: "/games", testid: "nav-link-games" },
  { label: "PROJECTS", to: "/projects", testid: "nav-link-projects" },
  { label: "SERVICES", to: "/services", testid: "nav-link-services" },
  { label: "THE FORGE", to: "/about", testid: "nav-link-about" },
  { label: "JOURNAL", to: "/journal", testid: "nav-link-journal" },
  { label: "CONTACT", to: "/contact", testid: "nav-link-contact" },
];

export const TERRITORIA = {
  slug: "territoria",
  title: "TERRITORIA",
  status: "IN DEVELOPMENT",
  genre: "PERSISTENT GEOPOLITICAL MMO",
  engine: "TERRITORIA ENGINE V0.0.007",
  target: "STEAM // BROWSER // IOS // ANDROID",
  betaDate: "2027-01-01T12:00:00Z",
  tagline: "137 Nations. 685 Regions. One World. No Resets.",
  keyArt: IMG.keyArt,
  heroArt: IMG.heroLandscape,
  synopsis:
    "Territoria is a persistent multiplayer political, economic and military simulator where every citizen helps shape the future of the world. Every border, law, coalition, election and war is shaped by players. Build an economy, lead a government, command armies — and alter the course of history.",
  video: "/territoria-devbuild.mp4",
  links: {
    world: "https://territoria.world/",
    codex: "https://territoria.wiki/wiki",
    discord: "https://discord.gg/TheArsenal",
  },
  buildStats: [
    ["VERSION", "0.0.007"],
    ["STATUS", "ALPHA // PIONEER SERVER"],
    ["ROADMAP", "52% COMPLETE"],
    ["OPEN BETA", "01.01.2027"],
  ],
  careers: [
    {
      code: "SOLDIER",
      motto: "Hold the line.",
      body: "The frontline backbone of a nation during global conflicts. Regiments, battle orders, liberation campaigns.",
    },
    {
      code: "ENTREPRENEUR",
      motto: "The Producers.",
      body: "The industrial foundation of a completely player-driven economy — factories, blueprints and supply chains.",
    },
    {
      code: "TRADER",
      motto: "The Market Masters.",
      body: "The flow of wealth, arbitrage and logistics across borders. National and global marketplaces.",
    },
    {
      code: "POLITICIAN",
      motto: "The National Leaders.",
      body: "Legislative, diplomatic and fiscal direction of an entire country. Laws, elections, coalitions.",
    },
  ],
  pillars: [
    {
      code: "01",
      title: "A Player-Shaped World",
      body: "Every border, law, coalition, election and war is decided by the citizens living inside the simulation.",
    },
    {
      code: "02",
      title: "A Player-Driven Economy",
      body: "Dual currency — TerraCoin and national fiat. Regional resources, production chains and markets with no NPC safety net.",
    },
    {
      code: "03",
      title: "Total War & Diplomacy",
      body: "Occupations, resistance wars, coalitions of up to five sovereign states, sanctions and embargoes — politics with consequences.",
    },
  ],
  gallery: [
    { src: "/territoria/world-map.webp", caption: "World view — pioneer server, live build" },
    { src: "/territoria/europe-theatre.webp", caption: "European theatre — borders and citizens" },
    { src: "/territoria/citizen-profile.webp", caption: "Citizen profile — equipment, wealth and national office" },
    { src: "/territoria/orbital-view.webp", caption: "Orbital view — day-night cycle over the world" },
  ],
  roadmap: [
    { phase: "PHASE 1", label: "Foundations of Conflict", done: true },
    { phase: "PHASE 2", label: "Economy & Logistics", done: true },
    { phase: "PHASE 3", label: "Nations & Governance", done: true },
    { phase: "PHASE 4", label: "Coalitions & Diplomacy", done: false },
    { phase: "PHASE 5", label: "Information & Intelligence", done: false },
    { phase: "PHASE 6", label: "National Development", done: false },
    { phase: "PHASE 7", label: "Global Expansion", done: false },
  ],
};

export const ARTICLES = [
  {
    slug: "kronix-first-transmission",
    date: "AUGUST 21, 2026",
    category: "STUDIO NEWS",
    readTime: "3 MIN",
    title: "Second Signal: A New World Answers — KRONIX",
    summary:
      "The vault opens a second door. KRONIX enters concept phase: a high-energy isometric action MMORPG.",
    image: "/kronix/key-art.png",
    body: [
      {
        type: "p",
        text: "The vault was never meant to hold one world. Today a second signal answers: KRONIX has entered concept phase at Arsenal Forge — a high-energy isometric action MMORPG built around ancient arenas, temporal constructs and combat you can read at a glance.",
      },
      { type: "h2", text: "Why a second project" },
      {
        type: "p",
        text: "Territoria is a long, patient forge — persistent worlds take years. KRONIX is a different discipline: fast, expressive, violent colour. Running a second line lets the studio exercise different muscles without slowing the first. Small team, big worlds — plural.",
      },
      {
        type: "quote",
        text: "Some worlds are forged slowly, under pressure. Others are struck while the iron is screaming hot.",
      },
      {
        type: "p",
        text: "What exists today is concept key art and a combat thesis: exaggerated weapons, vibrant particle trails, expressive poses, and a golem that glows like a dying star. The roster, classes and release window remain classified — deliberately. We show work when it's worth showing.",
      },
      { type: "h2", text: "What happens next" },
      {
        type: "p",
        text: "KRONIX development dispatches will land here in the Forge Journal as the concept hardens. The teaser page is live in the vault — first transmission details will follow when there is something real to say. Depth over frequency, as always.",
      },
    ],
  },
  {
    slug: "territoria-devlog-04",
    date: "JULY 14, 2026",
    category: "DEV LOGS",
    readTime: "6 MIN",
    title: "The Two-Minute Tick: How Wars Are Actually Won in Territoria",
    summary:
      "Damage pools, terrain gain and the best-of-three round system — inside the combat resolution engine.",
    image: "/territoria/citizen-profile.webp",
    body: [
      {
        type: "p",
        text: "War in Territoria is not a cutscene. When a nation declares war and regiments cross a border, the outcome is resolved by a combat engine that runs on two-minute ticks — and every tick is fed by real logistics, real equipment and real citizens standing in the region.",
      },
      { type: "h2", text: "Presence is power" },
      {
        type: "p",
        text: "There is a physical-presence requirement: damage only counts when your soldiers are actually there. A superpower cannot click a map from safety. Armies must be moved, supplied and held — which is why ammunition production chains quietly decide who wins long wars.",
      },
      {
        type: "quote",
        text: "Terrain gain is earned in rounds, not in spreadsheets. Best of three. Every round is a fight someone showed up to.",
      },
      {
        type: "p",
        text: "Damage pools accumulate across each round, terrain gain shifts the front line, and the best-of-three round system means a battle can turn. Resistance bonuses — from +1% up to +40% — mean an occupied people never stop being a threat to their occupier.",
      },
      { type: "h2", text: "Why it has to hurt" },
      {
        type: "p",
        text: "Because the world is persistent and there are no resets, every war leaves a permanent mark on the map. A region lost is a region someone else now governs, taxes and builds on — until a liberation campaign takes it back.",
      },
      {
        type: "p",
        text: "Next dispatch: TerraCoin, national fiat, and why we built a currency no government in the game can control.",
      },
    ],
  },
  {
    slug: "small-team-big-worlds",
    date: "JUNE 28, 2026",
    category: "STUDIO NEWS",
    readTime: "4 MIN",
    title: "Small Team, Big Worlds: Why Independence Matters",
    summary:
      "How a compact team structure enables bolder mechanical risks and a unified art direction.",
    image: IMG.studioSetup,
    body: [
      {
        type: "p",
        text: "Arsenal Forge is deliberately small. Not small as a limitation — small as a weapon. Every person in the studio touches the world directly. There is no layer of abstraction between the idea and the build.",
      },
      { type: "h2", text: "No committees, no dilution" },
      {
        type: "p",
        text: "A persistent geopolitical simulator with 137 nations and no resets is not the kind of idea that survives a corporate approval chain. Large productions optimise for consensus. Consensus produces safe worlds. We would rather ship a world with a strong opinion.",
      },
      {
        type: "quote",
        text: "A small team cannot out-spend anyone. It can only out-care everyone.",
      },
      {
        type: "p",
        text: "The same person who designed the resistance-warfare bonus tuned it on the pioneer server alongside our first forty players. That continuity of authorship is what makes a world feel forged instead of assembled.",
      },
      {
        type: "p",
        text: "We are not hiring by the hundred. We are building by the hand. That is the whole model.",
      },
    ],
  },
  {
    slug: "modular-forge-system",
    date: "JUNE 10, 2026",
    category: "TECHNOLOGY",
    readTime: "5 MIN",
    title: "One Million TerraCoin: Forging a Currency No Government Can Touch",
    summary:
      "Citizen-owned mining, a hard supply cap, and a proof-of-work economy that lives outside state control.",
    image: "/territoria/europe-theatre.webp",
    body: [
      {
        type: "p",
        text: "Every nation in Territoria prints its own fiat currency. Parliaments tax it, treasuries hold it, and wars are funded by it. So we asked a dangerous question: what happens to a player-driven economy when there is one currency no government can print, seize or devalue?",
      },
      { type: "h2", text: "TerraCoin" },
      {
        type: "p",
        text: "TerraCoin runs on proof-of-work with a hard cap of one million. Mining companies are citizen-owned, hash power is a resource you build, and the chain stays deliberately outside government control. States can tax trade in it — they cannot mint it.",
      },
      {
        type: "quote",
        text: "Fiat is politics. TerraCoin is physics. A healthy economy needs both.",
      },
      {
        type: "p",
        text: "The dual-currency system creates real arbitrage. Traders move wealth across borders between national fiat and TC, watching the Economic Health Index like a weather report. When a nation collapses, its fiat goes with it — and the market decides the rest.",
      },
      {
        type: "p",
        text: "Full economic reference is live in the codex. The ledger, as always, belongs to the players.",
      },
    ],
  },
  {
    slug: "territoria-first-transmission",
    date: "MAY 22, 2026",
    category: "STUDIO NEWS",
    readTime: "3 MIN",
    title: "First Transmission: Introducing Territoria",
    summary:
      "Our flagship project steps out of the dark. One persistent world, shaped entirely by its players.",
    image: "/territoria/orbital-view.webp",
    body: [
      {
        type: "p",
        text: "Today we break silence. Territoria — our flagship title — is in active development at Arsenal Forge: a persistent multiplayer political, economic and military simulator. 137 nations. 685 regions. One world. No resets.",
      },
      { type: "h2", text: "Built from the ground up" },
      {
        type: "p",
        text: "Every border, law, coalition, election and war is shaped by players. Build an economy, lead a government, command armies, and alter the course of history. A pioneer server is already live — forty citizens are helping us forge the world in the open, build by build.",
      },
      {
        type: "quote",
        text: "We forge worlds. Territoria is the first one we are ready to talk about.",
      },
      {
        type: "p",
        text: "Development dispatches will land here in the Forge Journal as milestones complete. Expect depth over frequency — we speak when there is something worth saying.",
      },
    ],
  },
];

export const PLUGIN_SUITE = [
  {
    name: "ArsenalWebStats",
    domain: "STATISTICS ENGINE",
    body: "The competitive statistics bridge. Kills, K/D, headshots, accuracy, raiding, farming, playtime and leaderboards — tracked per wipe, per season, and across a player's entire career on the network.",
  },
  {
    name: "ArsenalMenu",
    domain: "IN-GAME INTERFACE",
    body: "A fully custom CUI experience: player profiles, public stats, ranks, clans, kits and Discord account linking — all without leaving the game.",
  },
  {
    name: "ArsenalAuth",
    domain: "IDENTITY LINKING",
    body: "Secure Steam ↔ Discord account verification with nickname sync and entitlement recognition shared across every Arsenal system.",
  },
  {
    name: "ArsenalClans",
    domain: "NETWORK-WIDE CLANS",
    body: "Clans that live across the whole network, not a single server — identities, avatars, public profiles and clan statistics that survive the wipe.",
  },
  {
    name: "ArsenalKits",
    domain: "PACKAGES & ENTITLEMENTS",
    body: "VIP through Arsenal-tier packages with claim cooldowns, post-wipe lockouts, backpack access and Discord-linked benefits.",
  },
  {
    name: "ArsenalReleaseBridge",
    domain: "TELEMETRY & DEPLOYMENT",
    body: "Live server telemetry — CPU, memory, FPS, entities, players — plus release metadata flowing into Arsenal Core for network-wide deployment management.",
  },
  {
    name: "Gameplay Tuning Suite",
    domain: "LOOT · GATHER · CRAFT · STACKS",
    body: "ArsenalLoot, ArsenalGather, ArsenalCraft and ArsenalStacks: per-server balance configurations tuned per game mode, from 2X Vanilla+ to 10X No BP.",
  },
  {
    name: "ArsenalSort",
    domain: "QUALITY OF LIFE",
    body: "A custom inventory sorting system with a compact Arsenal-branded bar — small tool, obsessive polish.",
  },
];

export const PLUGIN_PILLARS = [
  {
    code: "01",
    title: "Competitive Statistics",
    body: "Combat, farming, raiding, world events, economy and activity — architected for wipe, season and career-level tracking across the network.",
  },
  {
    code: "02",
    title: "Identity & Community",
    body: "One canonical player identity: Steam, Discord, profile, clan, stats and entitlements. Never five copies of the same player.",
  },
  {
    code: "03",
    title: "Live Operations",
    body: "Network-managed code, server-managed config. Release channels, health verification and rollback — deployments that respect each server's identity.",
  },
];

export const DEPLOY_PIPELINE = [
  "DEVELOP",
  "LOCAL TESTING",
  "2X GOLD MASTER",
  "VALIDATION",
  "NETWORK DEPLOYMENT",
  "HEALTH VERIFICATION",
  "RELEASE REPORT",
];

export const RUST_NETWORK = [
  { name: "Arsenal 2X", mode: "SOLO / DUO / TRIO · VANILLA+ · SHARED BP", region: "AU", role: "GOLD MASTER" },
  { name: "Arsenal 3X", mode: "SOLO / DUO / TRIO · LOOT+ · SHARED BP", region: "AU" },
  { name: "Arsenal 5X PVE", mode: "LOOT+", region: "AU" },
  { name: "Arsenal 5X NO BP", mode: "SOLO / DUO / TRIO · LOOT+", region: "AU" },
  { name: "Arsenal 10X NO BP", mode: "SOLO / DUO / TRIO · LOOT+", region: "AU" },
];

export const JOURNAL_CATEGORIES = ["ALL", "DEV LOGS", "WORLDS", "TECHNOLOGY", "STUDIO NEWS"];

export const CRAFT_PILLARS = [
  {
    code: "01",
    title: "LIVING WORLDS",
    body: "Worlds with history in every border, law and battlefield. Built to be believed, not just seen.",
  },
  {
    code: "02",
    title: "MECHANICAL RIGOR",
    body: "Systems that interlock with intent. No feature survives unless it deepens the world.",
  },
  {
    code: "03",
    title: "UNCOMPROMISED VISION",
    body: "Independent by design. No committees, no dilution — the idea reaches the player intact.",
  },
];
